export default __webpack_public_path__ + "static/media/3034.72cf3476.jpg";